import { Head } from '@inertiajs/react'
import type { ReactNode } from 'react'

import { ComingSoon } from '@/components/ComingSoon'
import { PageHeader } from '@/components/PageHeader'
import { DashboardLayout } from '@/layouts/DashboardLayout'

function LimitedPartnersIndex() {
  return (
    <>
      <Head title="Limited partners" />

      <div className="mx-auto max-w-6xl px-8 py-10">
        <PageHeader
          title="Limited partners"
          description="Institutions and their investment vehicles backing our funds."
        />

        <ComingSoon
          title="To implement"
          description="List of LP institutions with their vehicles, aggregate commitments across funds and capital-call standing."
        />
      </div>
    </>
  )
}

export default Object.assign(LimitedPartnersIndex, {
  layout: (page: ReactNode) => <DashboardLayout>{page}</DashboardLayout>,
})
